/**
 * Music-theory Unicode glyphs that screen readers announce inconsistently
 * (or with the literal Unicode name like "music flat sign"). See
 * {@link ./theory-glyphs.tsx} for the visible-text JSX rendering pattern.
 */
const GLYPH_TO_SPOKEN: Record<string, string> = {
  '♭': 'flat',
  '♯': 'sharp',
  '°': 'diminished',
}

/**
 * Convert music-theory text with Unicode glyphs into spoken-language form
 * for string contexts (`title=`, `aria-label=`). Use {@link TheoryGlyphs}
 * for visible-text contexts.
 *
 * @example
 *   spokenText('♭VII comes from Mixolydian')
 *   // → 'flat VII comes from Mixolydian'
 *   spokenText('♯IV°')
 *   // → 'sharp IV diminished'
 */
export const spokenText = (text: string): string => {
  let result = text
  for (const [glyph, spoken] of Object.entries(GLYPH_TO_SPOKEN)) {
    result = result.split(glyph).join(` ${spoken} `)
  }
  return result.replace(/\s+/g, ' ').trim()
}
